export default {
    render (h) {
        return h('input',{
            ref: 'valueInput',
            props: {
                value: this.value
            }
        })
    },
    model:{
        event: 'changemodel'
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-base-components-vue-wrapper/src/kendo-base-input-component/index.js